module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-01-en.54e56fb24bbdc39e86e801099e87438f.png";